import { FixedMarker, FixedMarkerOverrides } from 'baseui/map-marker';
import { memo, useEffect } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import { activeReportRouteState, reportHistoricLngLatsState, reportHistoricState } from '../../../storage/reports';

function RouteMarkers() {
  const assetId = useRecoilValue(activeReportRouteState);
  const states = useRecoilValue(reportHistoricState(assetId || ''))?.states;
  const lngLats = useRecoilValue(reportHistoricLngLatsState(assetId || ''));
  const { fitToLngLats } = useCamera();

  const fixedMarkerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
  };

  useEffect(() => {
    if (!lngLats.length) return;

    fitToLngLats(lngLats);
  }, [lngLats, assetId, fitToLngLats]);

  if (!states?.length || !assetId) return null;

  const first = states.at(0);
  const last = states.at(-1);

  if (!first || !last) return null;

  return (
    <>
      <Marker
        latitude={first.position_latitude}
        longitude={first.position_longitude}
      >
        <FixedMarker
          label="Inicio"
          size="small"
          overrides={fixedMarkerOverrides}
        />
      </Marker>
      <Marker
        latitude={last.position_latitude}
        longitude={last.position_longitude}
      >
        <FixedMarker
          label="Fin"
          size="small"
          overrides={fixedMarkerOverrides}
        />
      </Marker>
    </>
  );
}

export default memo(RouteMarkers);
